import React from 'react'
import { observer } from 'mobx-react'
import { CheckList, CheckListItem } from 'components/CheckList'

const ChoicesChallengeView = ({ challenge }) => (
  <div className="choices-challenge">
    <CheckList>
      {challenge.choices.map((choice) =>
        <CheckListItem
          small
          key={choice.value}
          onChange={(checked) => checked && challenge.setAnswer(choice.value)}
          checked={challenge.selectedValue === choice.value}
        >
          {choice.value}
        </CheckListItem>
      )}
    </CheckList>
  </div>
)

export default observer(ChoicesChallengeView)



// WEBPACK FOOTER //
// ./src/client/components/LinkAccountDialog/QuovoProvider/MultiFactorAuth/ChoicesChallenge/View.jsx